var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "rgb(88, 106, 218)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.00065463 6.58513217 4.59196787-4.59196788c.3908857-.39088574 1.0246367-.39088574 1.4155225 0 .3908857.39088573.3908857 1.02463672 0 1.41552245l-4.59131329 4.59131326 4.59131329 4.5913136c.3908857.3908857.3908857 1.0246367 0 1.4155225-.3908858.3908857-1.0246368.3908857-1.4155225 0l-4.59196787-4.59196791-4.59196789 4.59196791c-.39088573.3908857-1.02463672.3908857-1.41552245 0-.39088574-.3908858-.39088574-1.0246368 0-1.4155225l4.59131325-4.5913136-4.59131325-4.59131326c-.39088574-.39088573-.39088574-1.02463672 0-1.41552245.39088573-.39088574 1.02463672-.39088574 1.41552245 0z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon-cancel.0cecad07cadce1c6c19b4cba57f99cab.svg";
export { ForwardRef as ReactComponent };